import React from 'react'
import Typewriter from "typewriter-effect"
import profile from '../images/profile.jpg';
import {Stagger,Fade,FadeTransform} from 'react-animation-components';
import '../css/App1.css'
import '../css/About.css'
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto"></link>

const profileStyle={
    height:'200px',
    // border-radius:'50%'
};
const intro = ['I am Devanshu Dalal', 'I am a coding ethusaiast.', 'I like problem-solving','My interest lies in Machine learning and MERN Stack'];

function AboutUs() {
  return (
    <div>

        <div className="pattern">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#007bff" fill-opacity="1" d="M0,32L48,53.3C96,75,192,117,288,149.3C384,181,480,203,576,197.3C672,192,768,160,864,128C960,96,1056,64,1152,42.7C1248,21,1344,11,1392,5.3L1440,0L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
            <div className="geeks">
            <FadeTransform
                in
                transformProps={{
                    enterTransform: 'translateX(0px)',
                    exitTransform: 'translateX(100px)'
                }}
            >
                <div className="container">
                    <div style={{fontweight:"20px",margin:"30px"}} className="row ">
                        <div className="col-12 col-md-6 i-left align-self-center">
                            

                            <div className="col-12 col-md-6 image aboutUs-img align-self-center">
                                <img style={profileStyle} className="rounded-circle img-fluid" src={profile} alt="Profile Image"></img>
                            </div>
                            <div className="i-name">
                                {/* <Stagger in>
                                    {intro.map(
                                        item => (
                                            <Fade>
                                                <span>{item}</span>
                                            </Fade>
                                        )
                                    )}
                                </Stagger> */}
                                <span>Hi, I am</span>
                                <span>Devanshu Dalal</span>
                                <span>Junior CSE, VIT Pune</span>
                            </div>
                        </div>
                    
                        
                        <div className="col-12 col-md-6 aboutUs-content align-self-center">
                        

                            <div className="row justify-content-center">
                                <h3 className="animate-charcter">About Me:</h3>
                            </div>
                            <Fade in>
                            <div style={{color:"",fontWeight:"600"}} className="aboutme">
                                

                                {/* <div style={{fontWeight:"600"}} className="row justify-content-center">
                                    <Typewriter 
                                        options={{
                                            autoStart:true,
                                            loop:true,
                                            delay:40,
                                            color:"#33ccff",
                                            strings:[
                                                "I am Devanshu Dalal",
                                                "I am a coding ethusaiast.",
                                                "I like problem-solving",
                                                "My interest lies in Machine learning"
                                            ]
                                        }}
                                    />
                                </div> */}
                                {/* <Stagger in>
                                    <div style={{fontWeight:"600"}} className="row justify-content-center desc">
                                    {intro.map(
                                        item => (
                                            <Fade>
                                                <Typewriter 
                                                    options={{
                                                        autoStart:true,
                                                        loop:true,
                                                        delay:40,
                                                        color:"#33ccff",
                                                        strings:[
                                                            {item}
                                                        ]
                                                    }}
                                                />
                                            </Fade>
                                        )
                                    )}
                                    </div>
                                </Stagger>  */}
                                {/* <div style={{fontWeight:"600"}} className="row justify-content-center desc">
                                <Typewriter 
                                        options={{
                                            autoStart:true,
                                            loop:true,
                                            delay:40,
                                            color:"#33ccff",
                                            strings:[
                                                "I am Devanshu Dalal"
                                            ]
                                        }}
                                    />
                                </div> */}
                                <div className="row justify-content-center desc">
                                <Typewriter 
                                        options={{
                                            autoStart:true,
                                            loop:true,
                                            delay:40,
                                            color:"#33ccff",
                                            strings:[
                                                "I am a coding ethusaiast."
                                            ]
                                        }}
                                    />
                                </div>
                                <div className="row justify-content-center desc">
                                    <Typewriter 
                                        options={{
                                            autoStart:true,
                                            loop:true,
                                            delay:40,
                                            color:"#33ccff",
                                            strings:[
                                                "I like problem-solving"
                                            ]
                                        }}
                                    />
                                </div>
                                <div className="row justify-content-center desc">
                                    <Typewriter 
                                        options={{
                                            autoStart:true,
                                            loop:true,
                                            delay:40,
                                            color:"#33ccff",
                                            strings:[
                                                "My interest lies in Machine learning and MERN Stack"
                                            ]
                                        }}
                                    />
                                </div>
                            </div>
                            </Fade>
                        </div>

                        
                    </div>
                </div>
                </FadeTransform>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fill-opacity="1" d="M0,32L48,53.3C96,75,192,117,288,149.3C384,181,480,203,576,197.3C672,192,768,160,864,128C960,96,1056,64,1152,42.7C1248,21,1344,11,1392,5.3L1440,0L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
                    
        </div>
    </div>
  )
}

export default AboutUs